class RestWMSService {
    constructor(options) {
        const deserializer = new g2.core.Deserializer();
        const restHttp = new g2.core.RestHttp();
        const url = options.layerOptions.url.split('/wms')[0];
        if (window.egis) {
            this.service = new g2.ews.RestWMSService({
                url: url,
                http: restHttp,
                deserializer: deserializer
            });
        } else {
            this.service = new g2.ows.RestWMSService({
                url: url,
                http: restHttp,
                deserializer: deserializer
            });
        }
    }
    getFeatureInfo(options) {
        return new Promise(async (resolve, reject) => {
            if (window.egis) {
                const extent = options.extent;
                const featureInfoInput = new g2.ews.FeatureInfoInput({
                    layers: options.layers,
                    crs: options.srs,
                    // bbox: extent.miny + ',' + extent.minx + ',' + extent.maxy + ',' + extent.maxx,
                    bbox: extent,
                    width: options.width,
                    height: options.height,
                    query_layers: options.layers,
                    info_format: options.format,
                    i: options.x,
                    j: options.y,
                });
                const promise = this.service.getFeatureInfo(featureInfoInput);
                promise.then(function(data) {
                    resolve(data);
                })
            } else {
                this.service.getFeatureInfo(options.layers, [options.layers], options.featureCount, options.extent, options.width, options.height, options.x, options.y, options.srs, options.buffer, options.format).then(function(data){
                    resolve(data);
                })
            }
            
        })
      
    }
}

module.exports = RestWMSService;